import React from 'react';
import { Container, Wrapper, Text, Link, Span,Img } from './styles/footer';

export default function Footer({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>;
}

Footer.Wrapper = function FooterWrapper({ children, ...rest }) {
  return <Wrapper {...rest}>{children}</Wrapper>;
};

Footer.Text = function FooterText({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>;
};

Footer.Link = function FooterLink({ children, ...rest }) {
  return (
    <Link target='_blank' {...rest}>
      {children}
    </Link>
  );
};

Footer.Span = function FooterSpan({ children, ...rest }) {
  return <Span {...rest}>{children}</Span>;
};

Footer.Img = function FooterImg({ children, ...rest }) {
  return <Img {...rest} />;
};
